/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './user';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './user';

/**
 * 
 * @export
 * @interface UserListResponse
 */
export interface UserListResponse {
    /**
     * A list of users.
     * @type {Array<User>}
     * @memberof UserListResponse
     */
    users: Array<User>;
}

/**
 * Check if a given object implements the UserListResponse interface.
 */
export function instanceOfUserListResponse(value: object): value is UserListResponse {
    if (!('users' in value) || value['users'] === undefined) return false;
    return true;
}

export function UserListResponseFromJSON(json: any): UserListResponse {
    return UserListResponseFromJSONTyped(json, false);
}

export function UserListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'users': ((json['users'] as Array<any>).map(UserFromJSON)),
    };
}

export function UserListResponseToJSON(json: any): UserListResponse {
    return UserListResponseToJSONTyped(json, false);
}

export function UserListResponseToJSONTyped(value?: UserListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': ((value['users'] as Array<any>).map(UserToJSON)),
    };
}

